import { theme } from '@frontend/theme';
import { Tabs, useModalControl } from '@frontend/design-system';
import { CreateNewFeatureFlag } from './create-new-feature-flag';
import { CustomizationFlagsTable } from './customization-flags';
import { LocationFeatureFlagTable } from './location-feature-flag-table';

export const LocationFeatureFlags = () => {
  const modalControl = useModalControl();

  return (
    <>
      <Tabs initialTab='table'>
        <Tabs.Bar
          css={{
            background: theme.colors.white,
            width: 'fit-content',
            borderTopRightRadius: '8px',
            borderTopLeftRadius: '8px',
            '& button:hover:not(:disabled)': {
              background: theme.colors.neutral10,
            },
            '& button:focus': {
              background: theme.colors.white,
            },
          }}
        >
          <Tabs.Tab id='table'>Feature Flags</Tabs.Tab>
          <Tabs.Tab id='customizations'>Customizations</Tabs.Tab>
        </Tabs.Bar>
        <Tabs.Panel controller='table'>
          <div
            style={{
              background: theme.colors.white,
              padding: theme.spacing(3),
              borderRadius: theme.borderRadius.medium,
              boxShadow: theme.shadows.light,
            }}
          >
            <LocationFeatureFlagTable />
          </div>
        </Tabs.Panel>
        <Tabs.Panel controller='customizations'>
          <div
            style={{
              background: theme.colors.white,
              padding: theme.spacing(3),
              borderRadius: theme.borderRadius.medium,
              boxShadow: theme.shadows.light,
            }}
          >
            <CustomizationFlagsTable />
          </div>
        </Tabs.Panel>
      </Tabs>
      <CreateNewFeatureFlag {...modalControl.modalProps} />
    </>
  );
};

export { FeatureFlagTableFilters } from './feature-flag-table-filters';
export { GlobalFeatureFlagTable } from './global-feature-flag-table';
